import HTMLTemplate from './template.html'
import './styles.scss'
import Airport from '../../modules/airport'
import { MyAirports } from '../MyAirports/MyAirports'
import User from '../../modules/user'
import Tails from '../../modules/tails'
import { MyFleet } from './../MyFleet/MyFleet'
import { MyRoutes } from './../MyRoutes/MyRoutes'
import { debounce } from 'lodash'
import ClientPortalAPIService from '../../services/api/ClientPortal/ApiService'
import Sentry from '../../modules/SantryIO'
import MixPanelService from '../../services/MixPanelService'
import Papa from 'papaparse'

export const ModalComponent = (() => {
    const vueComponent = {
        data() {
            return {
                showWatchlistModal: false,
                showAirportAddedModal: false,
                airportCodeToAdd: '',
                addToWatchFromLocation: '',
                isLoading: false,
                showAddTailModal: false,
                showAddTailSuccessModal: false,
                tailErrorMessage: '',
                tailNumberToAdd: '',
                errorMessage: '',
                stopTrackingIdentifier: {},
                showAddRouteModal: false,
                routePlanString: '',
                routesOriginAirport: '',
                isLoadingOriginAirportDetails: false,
                originAirportName: '',
                originAirportICAOCode: '',
                originAirportSearchError: '',
                routesDestinationAirport: '',
                isLoadingDestinationAirportDetails: false,
                destinationAirportSearchError: '',
                destinationAirportName: '',
                destinationAirportICAOCode: '',
                hasSumbitedAddRouteForm: false,
                tailsFileName: 'Upload File'
            }
        },
        methods: {
            addAirport() {
                this.isLoading = true

                const userSpecifiedAirportCode = this.airportCodeToAdd.trim().toUpperCase()

                // Check if the code provided is not empty
                if (userSpecifiedAirportCode === '') {
                    this.errorMessage = "Airport code is mandatory."
                    this.isLoading = false
                    return false
                }

                // Get the corresponding ICAO code if it is an IATA code
                let userSelectedAirport = null
                if (userSpecifiedAirportCode.length === 3) {
                    userSelectedAirport = Airport.getAirportByIATACode(userSpecifiedAirportCode)
                } else if (userSpecifiedAirportCode.length === 4) {
                    userSelectedAirport = Airport.getAirportByICAOCode(userSpecifiedAirportCode)
                }

                if (userSelectedAirport === null || userSelectedAirport === undefined) {
                    this.errorMessage = 'We were unable to find an airport that matched the code you entered. Please check and retry your search.'
                    this.isLoading = false
                    return false
                }

                MixPanelService.track('Airports Add to Watchlist', { 
                    'Clicked Location': this.addToWatchFromLocation,
                    'Airport Name': userSelectedAirport?.Name || '',
                    'ICAO': userSelectedAirport?.ICAO || '',
                    'IATA': userSelectedAirport?.IATA || '',
                    'Country': userSelectedAirport?.Country || '',
                    'Country Code': userSelectedAirport?.Isocode3 || '',
                    'City': userSelectedAirport?.City || ''
                })

                // Fetch latest user watchlist and check if the airport is or not already there
                User.getUser().then(userInfo => {
                    if (userInfo.settings.airportsWatchlist.indexOf(userSelectedAirport.ICAO) > -1) {
                        this.errorMessage = 'Airport is already in your watchlist.'
                        this.isLoading = false
                        return false
                    } else {
                        User.addAirportToUserWatchlist(userSelectedAirport.ICAO)

                        this.showWatchlistModal = false
                        this.showAirportAddedModal = true
                        this.isLoading = false

                        window.setTimeout(() => MyAirports.update(), 500)
                    }
                })
            },
            addTail() {
                const uploadedFile = this.$refs?.tailsFile?.files?.[0] || null

                if (uploadedFile) {
                    const reader = new FileReader()

                    // It's a little tricky to do front-end valdation of CSV files, I think we will make few assumptions. For more info:
                    // About MIME type validation: https://stackoverflow.com/a/42140178/2052173
                    const allowedFileTypes = ['text/plain', 'application/vnd.ms-excel', 'text/x-csv', 'application/csv', 'application/x-csv', 'text/csv', 'text/comma-separated-values', 'text/x-comma-separated-values', 'text/tab-separated-values']

                    if (uploadedFile === undefined) {
                        this.tailErrorMessage = 'File input is a required field'
                        return false
                    }

                    if (allowedFileTypes.indexOf(this.$refs.tailsFile.files[0].type) === -1) {
                        this.tailErrorMessage = 'You have uploaded an unsupported filetype. Please ensure you are uploading a .CSV file with standard formatting.'
                        this.tailsFileName = 'Upload File'
                        this.$refs.tailsFile.value = ''
                        return false
                    }

                    this.filedCSVtails = []

                    reader.onload = (event) => {
                        const papaParseResults = Papa.parse(event.target.result)

                        // It's hard to decide what error we should handle, we ask for a simple list, so in this case the library will thoww:
                        // "Unable to auto-detect delimiting character; defaulted to ','", which we don't care, as we ask for just a simple list
                        // Leave unhandled as for now and handle papaParseResults.errors if it will reveal to be necessary 
                        console.log('Result of the parsef file from Papaparse', papaParseResults)

                        if (!!papaParseResults.data) {
                            let tailNumbersToUpload = []
                            papaParseResults.data.forEach(CSVLine => {
                                // Assumption is that a tail number is first element on the row, we don't care about the rest
                                if (CSVLine[0].trim() !== '') {
                                    if (CSVLine[0].includes('/') || CSVLine[0].includes('\\')) {
                                        this.filedCSVtails.push(CSVLine[0])
                                    } else {
                                        tailNumbersToUpload.push(CSVLine[0])
                                    }
                                }
                            })

                            if (tailNumbersToUpload.length === 0) {
                                this.tailErrorMessage = 'Could not read any tail numbers from the file'
                                return false
                            }

                            this.numberOfTailsToUpload = tailNumbersToUpload.length
                            let commaSeparatedTailNumbers = tailNumbersToUpload.join(',')
                            this.isUploadingTails = true
                            this.addUserTailApiCall(commaSeparatedTailNumbers, true)
                        }
                    }
                    reader.readAsText(uploadedFile)

                } else {
                    const tailNumber = this.tailNumberToAdd.trim()
                    if (tailNumber === '') {
                        this.tailErrorMessage = 'Tail number is a required field'
                    } else if (tailNumber.includes('/')) {
                        this.tailErrorMessage = 'Tail Numbers with “/” are not accepted. Please update and try again.'
                    } else if (tailNumber.includes('\\')) {
                        this.tailErrorMessage = 'Tail Numbers with “\\” are not accepted. Please update and try again.'
                    } else {
                        this.addUserTailApiCall(tailNumber, false)
                    }
                }
            },
            addUserTailApiCall(tailNumber, isBulkUpload) {
                this.isLoading = true
                ClientPortalAPIService.addUserTail({ tails: tailNumber }).then(response => {
                    if (response.length > 0) {
                        Tails.update()
                        if (isBulkUpload) {
                            MixPanelService.track('Add Tails (Bulk upload)', { 'Tail Numbers': tailNumber })
                        } else {
                            MixPanelService.track('Add Tail', { 'Tail Number': tailNumber })
                        }
                        window.setTimeout(() => {
                            this.isLoading = false
                            this.showAddTailModal = false
                            this.tailNumberToAdd = ''
                            this.showAddTailSuccessModal = true
                            this.tailsFileName = 'Upload File'
                            this.$refs.tailsFile.value = ''
                            MyFleet.update(response)
                        }, 3000)
                    }
                }).catch(error => {
                    Sentry.captureException(error)
                    window.alert('Could not add tail. Error message: ' + error)
                    this.tailErrorMessage = error
                })
            },
            showStopTrackingModal(identifier) {
                this.stopTrackingIdentifier = identifier
            },
            stopTracking() {
                this.isLoading = true

                ClientPortalAPIService.deleteUserTail(this.stopTrackingIdentifier.tailId).then(response => {
                    if (response === 'deleted!') {
                        MyFleet.softDeleteTail(this.stopTrackingIdentifier.tailId)
                        MixPanelService.track('Remove Tail', { 
                            'Tail Number': this.stopTrackingIdentifier.tailNumber
                        })
                        Tails.update()
                        this.isLoading = false
                        this.stopTrackingIdentifier = {}
                    }
                }).catch(error => {
                    Sentry.captureException(error)
                    window.alert('Could not stop tracking this aircraft. Error message: ' + error)
                    this.isLoading = false
                })
            },
            addRoute() {
                this.hasSumbitedAddRouteForm = true

                let planString = this.routePlanString.trim().toUpperCase()
                let originAirport = this.routesOriginAirport.trim().toUpperCase()
                let destinationAirport = this.routesDestinationAirport.trim().toUpperCase()

                // originAirportName & destinationAirportName will not be empty if the search found a valid airports
                if (planString !== '' && originAirport !== '' && destinationAirport !== '' && this.originAirportName !== '' && this.destinationAirportName !== '') {
                    this.isLoading = true

                    ClientPortalAPIService.decodeRoute(this.originAirportICAOCode, planString, this.destinationAirportICAOCode).then(response => {
                        if (response.error !== undefined) {
                            window.alert(response.error)
                            return false
                        }

                        if (response.data.decodeRouteResult.length >= 3 && response.successful) {
                            // The decoded route has at least 1 found position, and airport of origin and destination, we consider it as valid
                            User.addRoute(planString, response.data.decodeRouteResult).then(() => {
                                MyRoutes.update()

                                // Add some fake loading to allow My Routes section to updates, this could be improved later and handled precisely
                                window.setTimeout(() => {
                                    this.resetAddingRoute()
                                }, 1500)
                            }).catch(error => Sentry.captureException(error))
                        } else {
                            window.alert('Could not decode the route.')
                            this.isLoading = false
                        }
                    })

                    MixPanelService.track('Add Route', { 
                        'Origin Airport': this.originAirportICAOCode,
                        'Destination Airport': this.destinationAirportICAOCode
                    })
                }
            },
            resetAddingRoute() {
                this.routePlanString = ''
                this.routesOriginAirport = ''
                this.routesDestinationAirport = ''
                this.originAirportName = ''
                this.destinationAirportName = ''
                this.hasSumbitedAddRouteForm = false
                this.showAddRouteModal = false
                this.isLoading = false
            },
            debounceRoutesOriginAirportSearch: debounce(function () {
                this.searchRoutesOriginAirport()
            }, 1500),
            debounceRoutesDestinationAirportSearch: debounce(function () {
                this.searchRoutesDestinationAirport()
            }, 1500),
            searchRoutesOriginAirport() {
                let originAirport = this.routesOriginAirport.trim().toUpperCase()

                let userSelectedAirport = null
                if (originAirport.length === 3) {
                    userSelectedAirport = Airport.getAirportByIATACode(originAirport)
                } else if (originAirport.length === 4) {
                    userSelectedAirport = Airport.getAirportByICAOCode(originAirport)
                }

                if (userSelectedAirport === null || userSelectedAirport === undefined) {
                    this.originAirportSearchError = 'Airport not recognized'
                } else {
                    this.originAirportName = userSelectedAirport.Name
                    this.originAirportICAOCode = userSelectedAirport.ICAO
                }

                this.isLoadingOriginAirportDetails = false
            },
            searchRoutesDestinationAirport() {
                let destinationAirport = this.routesDestinationAirport.trim().toUpperCase()

                let userSelectedAirport = null
                if (destinationAirport.length === 3) {
                    userSelectedAirport = Airport.getAirportByIATACode(destinationAirport)
                } else if (destinationAirport.length === 4) {
                    userSelectedAirport = Airport.getAirportByICAOCode(destinationAirport)
                }

                if (userSelectedAirport === null || userSelectedAirport === undefined) {
                    this.destinationAirportSearchError = 'Airport not recognized'
                } else {
                    this.destinationAirportName = userSelectedAirport.Name
                    this.destinationAirportICAOCode = userSelectedAirport.ICAO
                }

                this.isLoadingDestinationAirportDetails = false
            },
            onFileUpload($event) {
                if ($event.target.files.length === 0) {
                    this.tailsFileName = 'Upload File'
                } else {
                    this.tailsFileName = $event.target.files[0].name
                }
            }
        },
        watch: {
            routesOriginAirport() {
                this.originAirportSearchError = ''
                this.originAirportName = ''
                this.originAirportICAOCode = ''

                if (this.routesOriginAirport.trim() === '') {
                    this.isLoadingOriginAirportDetails = false
                } else {
                    this.isLoadingOriginAirportDetails = true
                }

                this.debounceRoutesOriginAirportSearch()
            },
            routesDestinationAirport() {
                this.destinationAirportSearchError = ''
                this.destinationAirportName = ''
                this.destinationAirportICAOCode = ''

                if (this.routesDestinationAirport.trim() === '') {
                    this.isLoadingDestinationAirportDetails = false
                } else {
                    this.isLoadingDestinationAirportDetails = true
                }

                this.debounceRoutesDestinationAirportSearch()
            },
            'tailNumberToAdd': function () {
                if (this.tailNumberToAdd) {
                    this.tailNumberToAdd = this.tailNumberToAdd.toUpperCase()
                }
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-modal')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})()
